import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { PassKeyDeleteSuccessComponent } from "./pass-key-delete-success.component";


class PasskeyDeleteSuccessForm implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;
    userEmail: string;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    passKeyDeleteSuccessComponentRef: ComponentRef<PassKeyDeleteSuccessComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside PasskeyDeleteSuccessForm constructor');
        this.formId = formId;
        this.payload = payload;
        this.userEmail = payload['email'];
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('PasskeyDeleteSuccessForm session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('PasskeyDeleteSuccessForm session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('PasskeyDeleteSuccessForm session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<PassKeyDeleteSuccessComponent> =
        self.resolver.resolveComponentFactory(PassKeyDeleteSuccessComponent);

        self.passKeyDeleteSuccessComponentRef = self.viewContainerRef.createComponent(factory);
        self.passKeyDeleteSuccessComponentRef.instance.onCloseLinkSubmit = self.onCloseSubmit.bind(self);
        self.passKeyDeleteSuccessComponentRef.instance.userEmail = self.userEmail;

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));
              console.log('PasskeyDeleteSuccessForm createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('PasskeyDeleteSuccessForm createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('PasskeyDeleteSuccessForm SuccessTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('PasskeyDeleteSuccessForm SuccessTs onError for ' + this.formId + ' payload:', payload);
      }

      private onCloseSubmit() {
        this.submitBlock(null);
      }
}

export default PasskeyDeleteSuccessForm;
